// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"27":"vendors/vendors--create-projection-node.mjs","852":"vendors/vendors--VisualElementDragControls.mjs","912":"vendors/vendors--index.mjs"}[chunkId] || chunkId) + ".bundle.js";
};